/**
 * Auth Layout
 * Layout for authentication pages (login, etc.)
 */

import { Outlet } from 'react-router';

export function AuthLayout() {
    return (
        <div className="flex min-h-screen items-center justify-center bg-background">
            <div className="w-full max-w-md p-6">
                <div className="mb-8 text-center">
                    <h1 className="text-3xl font-bold text-primary">MTOMICS</h1>
                    <p className="mt-2 text-muted-foreground">Master Data Management Platform</p>
                </div>
                <Outlet />
            </div>
        </div>
    );
}
